import { createI18n } from "vue-i18n";
import { messages } from './langs/index'



export default createI18n({
    locale: localStorage.getItem("user-locale") ?? 'en',
    // locale: 'ar',
    fallbackLocale: "en",
    globalInjection: true,
    legacy: false,
    formatFallbackMessages: true,
    messages
})
